import * as yup from 'yup'

// Shared by create and update - the backend validates both the same way.
// Excluded barcodes are also checked against the catalogue server-side;
// those messages come back as a toast.
export const freshCategorySchema = yup.object().shape({
  name: yup.string().trim().required('Category name is required'),
  excludedBarcodes: yup.string().trim(),
  image: yup.string(),
  isActive: yup.boolean(),
})

export type FreshCategoryFormFields = yup.InferType<typeof freshCategorySchema>
